// extracted by mini-css-extract-plugin
export default {"card":"styles_card__9rXdD","container":"styles_container__2o57c","laading":"styles_laading__6tESf","form":"styles_form__apUcW","banner":"styles_banner__GqMx8"};